import {useCallback, useMemo} from "react";
import {useCookies} from "react-cookie";
import {
    COOKIE_CONSENT_NAME,
    COOKIE_CONSENT_VERSION,
    getCookieConsentOptions,
    LEGACY_COOKIE_CONSENT_NAME,
    normalizeCookieConsent,
    removeGoogleAnalyticsCookies,
    setGoogleAnalyticsDisabled,
} from "../utils/CookieConsentUtils";

export default function useCookieConsent() {
    const [cookies, setCookie, removeCookie] = useCookies([
        COOKIE_CONSENT_NAME,
        LEGACY_COOKIE_CONSENT_NAME,
    ]);
    const consent = useMemo(
        () => normalizeCookieConsent(cookies[COOKIE_CONSENT_NAME]),
        [cookies]
    );

    const saveConsent = useCallback(
        (analytics) => {
            const nextConsent = {
                version: COOKIE_CONSENT_VERSION,
                analytics: !!analytics,
                updatedAt: new Date().toISOString(),
            };

            setCookie(
                COOKIE_CONSENT_NAME,
                nextConsent,
                getCookieConsentOptions()
            );
            removeCookie(LEGACY_COOKIE_CONSENT_NAME, {path: "/"});
            setGoogleAnalyticsDisabled(!nextConsent.analytics);

            if (!nextConsent.analytics) {
                removeGoogleAnalyticsCookies();
            }

            return nextConsent;
        },
        [removeCookie, setCookie]
    );
    const acceptAll = useCallback(() => saveConsent(true), [saveConsent]);
    const rejectOptional = useCallback(() => saveConsent(false), [saveConsent]);

    return {
        consent,
        hasDecision: !!consent,
        analytics: consent?.analytics === true,
        saveConsent,
        acceptAll,
        rejectOptional,
    };
}
